import axios from 'axios';
import { API_BASE_URL } from '../config';

export const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const counterAPI = {
    increment: () => api.post('/api/change-number', {
        operation: 'ADD',
        num: 1
    }),
    decrement: () => api.post('/api/change-number', {
        operation: 'MINUS',
        num: 1
    }),
    getCurrent: () => api.get('/api/counter/current'),
};

// Задания конструктора.
// id задания — UUID, его генерирует бэкенд и возвращает в ответ на создание.
// Формат задания: { id, title, exercises: [{ type: 'ADD_1_1', count: 5 }, ...] }
// Коды типов — см. src/components/taskConstructor/exerciseTypes.js
export const tasksAPI = {
    getAll: () => api.get('/api/tasks'),
    // тело: { title, exercises } -> ответ: { id, title, exercises }
    create: (task) => api.post('/api/tasks', task),
    // у сохранённого задания можно менять только название; тело: { id, title }
    updateTitle: (id, title) => api.patch(`/api/tasks/${id}`, { id, title }),
    // статистика игр по заданию: [{ id, name, playedAt, durationSeconds }]
    getGames: (id) => api.get(`/api/tasks/${id}/games`),
};

// Шахматный турнир: полное текущее состояние (игроки, матчи, результаты игроков в матчах).
// Ответ: { title, players, matches, matchPlayers } — разбор в src/components/chessTournament/tournamentData.js
export const tournamentAPI = {
    getData: (tournamentId) => api.get(`/api/chess/get-data/tournaments/${tournamentId}`),
};
